import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useEffect, useState } from "react";
import {
  AllWorkspace,
  DuplicateWorkspace,
  GetUser,
  WorkspaceUpdate,
  accessWorkspacedata,
  checkDeleteAccess,
  deleteWorkspace,
  getAllWorkspaces,
  renameWorkspace,
} from "../ApiServices/apiHandler";
import moment from "moment";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useHistory } from "react-router";

import swal from "sweetalert";
import { fetchWorkspace } from "../../../redux/actions/workspace/actionAllWrokspace";
import { useSelector, useDispatch } from "react-redux";
import "../../../WorkSpace/SignUp2.css";
import addTeamMemberIcon from "./../../../../src/assets/Image/workspaceIcon/addtmember.svg"
import duplicateIcon from "./../../../../src/assets/Image/workspaceIcon/duplicate.svg"
import renameIcon from "./../../../../src/assets/Image/workspaceIcon/rename.svg"
import deleteIcon from "./../../../../src/assets/Image/workspaceIcon/delete.svg"
import SendApproval from "../Modal/sendApproval";
import SendRequest from "../Modal/sendRequest";

import { Spinner } from "react-bootstrap";

import { motion } from "framer-motion";

import commoncss from "../../../myfin_v2/css/common.module.css";
import workspacecss from "../../../myfin_v2/css/workspace.module.css";
import cardcss from "../../../myfin_v2/css/card.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as MinimizeIcon } from "../../../myfin_v2/assets/icons/minimize.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import Sidebar from "../../../myfin_v2/elements/Sidebar"
import { Button } from "../../../myfin_v2/elements/Button"
import StatusIndicator from '../../../myfin_v2/elements/StatusIndicator';


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 789,
  height: 451,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};

const AllWorkspaceData = (props) => {
  const users = JSON.parse(localStorage.getItem('user'));
  const permissions = JSON.parse(localStorage.getItem('permission'));
  const [allWorkspace, setWorkspace] = useState([]);
  const [allAccessWorkspace, setAllAccessWorkspace] = useState([]);
  const [workspaceAll, setWorkspaceAll] = useState([]);
  const [allUser, setAllUser] = useState([]);
  const [anchorE2, setAnchorE2] = useState(null);
  const [workspaceDelete, setWorkspaceData] = useState("");
  const openTab = Boolean(anchorE2);
  const idTab = openTab ? "simple-popover" : undefined;
  const [WsPid, setWSp] = useState("");
  const dispatch = useDispatch();
  let history = useHistory();
  const [rename, setName] = useState("");
  const [renameId, setRenameID] = useState("");
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [search, setSearch] = useState('');
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [approverId, setApproverId] = useState("");
  const [openRequestModal, setOpenRequestModal] = useState(false);
  const [WID, setWID] = useState("");
  const [companyId, setCompanyIds] = useState([]);
  const [loader, setLoader] = useState(true);

  const handleClickWsp = (event, id, data) => {
    setAnchorE2(event.currentTarget);
    setWSp(id);
    setWorkspaceData(data);
  };
  const handleCloseTab = () => {
    setAnchorE2(null);
  };
  const handleClose = () => {
    setOpenRenameModal(false);
  };

  const handleOpenApprovalModal = () => setOpenApproveModal(true);
  const handleCloseApprovalModal = () => setOpenApproveModal(false);

  const handleOpenRequestModal = () => setOpenRequestModal(true);
  const handleCloseRequestModal = () => setOpenRequestModal(false);

  const handleApproverChange = (event) => {
    setApproverId(event.target.value);
  };

  useEffect(() => {
    accessWorkspace();
    allWorkSpace();
    WorkSpaceAll();
    GetAllUser();
  }, []);
  const allWorkSpace = async () => {
    const res = await getAllWorkspaces();
    if (res.status === 200) {
      setWorkspace(res.data.workspaces);
      setLoader(false)
    }
  };
  const nextStep = () => {
    if (users.responsibilities === "approver" || users.responsibilities === "view") {
      swal("Warning", "You Don't have Access to Create Workspace", "warning");
    } else {
      props.history.push("/workspacelayout");
    }
  };
  const WorkSpaceAll = async () => {
    const res = await AllWorkspace();
    if (res.status === 200) {
      setWorkspaceAll(res.data.workspace);
    }
  };
  const accessWorkspace = async () => {
    const res = await accessWorkspacedata();
    if (res.status === 200) {
      setAllAccessWorkspace(res.data.getAccessWorkspace);
    }
  };
  const handleClickData = (w_id) => {
    const statusSteps = workspaceAll.filter((adj) => adj._id === w_id);
    if (statusSteps[0]?.steps_status === "step1") {
      props.history.push(`/workspacesetup/${w_id}`);
    } else if (statusSteps[0]?.steps_status === "step2") {
      props.history.push(`/addCompanies/${w_id}`);
    } else if (statusSteps[0]?.steps_status === "step3") {
      props.history.push(`/importregister/${w_id}`);
    } else if (statusSteps[0]?.steps_status === "step4") {
      props.history.push(`/importPreset/${w_id}`);
    } else if (statusSteps[0]?.steps_status === "step5") {
      props.history.push(`/inviteteammember/${w_id}`);
    } else {
      props.history.push(`/overview/${w_id}`);
    }
  };

  const workspace = (wid, data) => {
    try {
      const nameWorkspace = workspaceAll.filter((adj) => adj._id === wid);
      const result = nameWorkspace[0]?.workspace_name
        ? nameWorkspace[0]?.workspace_name
        : "";
      if (data === "id") {
        return result;
      }
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };
  const workspaceCy = (wid, data) => {
    try {
      const cyWorkspace = workspaceAll.filter((adj) => adj._id === wid);
      const result = cyWorkspace[0]?.standalone_cy
        ? cyWorkspace[0]?.standalone_cy
        : "";
      if (data === "id") {
        return result;
      }
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };
  const workspacePy = (wid, data) => {
    try {
      const cyWorkspace = workspaceAll.filter((adj) => adj._id === wid);
      const result = cyWorkspace[0]?.standalone_py
        ? cyWorkspace[0]?.standalone_py
        : "";
      if (data === "id") {
        return result;
      }
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };
  const GetAllUser = async () => {
    const res = await GetUser();
    if (res.status === 200) {
      setAllUser(res.data.fetchUser);
    }
  };

  const UserName = (uid) => {
    try {
      const user = allUser.filter((adj) => adj._id === uid);
      const result = user[0]?.email ? user[0]?.email : "unknown";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const handleViewOnly = async (workspace_id, check) => {
    if (check === "on") {
      let data = {
        access_status: "view",
      };
      const res = await WorkspaceUpdate(data, workspace_id);
      if (res.status === 200) {
        console.log("success");
        swal("", "View Access On", "success");
        setAnchorE2(false);
        dispatch(fetchWorkspace());
        allWorkSpace();
      }
    } else if (check === "off") {
      let data = {
        access_status: "off",
      };
      const res = await WorkspaceUpdate(data, workspace_id);
      if (res.status === 200) {
        console.log("success");
        swal("", "View Access Off", "success");
        setAnchorE2(false);
        dispatch(fetchWorkspace());
        allWorkSpace();
      }
    }
  };
  const handleChangeData = (e) => {
    setName(e.target.value);
  };
  const submitCompany = async () => {
    const data = {
      workspaceName: rename,
    };
    const result = await renameWorkspace(renameId, data);
    if (result.status === 200) {
      swal("Success", "Workspace Renamed Successfully", "success");
      setAnchorE2(false);
      setOpenRenameModal(false);
      allWorkSpace().then(res => {
        dispatch(fetchWorkspace());
      }).catch(err => { })
    }
    console.log(result.data);
    if (result.data.status === false) {
      swal("", result.data.message, "error");
    }
  };
  const handleDuplicate = async (workspace_id) => {
    const res = await DuplicateWorkspace(workspace_id);

    if (res.status === 200) {
      dispatch(fetchWorkspace());
      handleCloseTab();
      allWorkSpace();
    }
  };
  const handleAddTeam = (workspace_id) => {
    history.push(`/inviteteammember/${workspace_id}`);
  };
  const handleRename = (workspace_id) => {
    if (users.responsibilities === "approver" || users.responsibilities === "view") {
      swal("warning", "You don't have access to rename workspace", "warning");
      return;
    }
    setOpenRenameModal(true);
    setRenameID(workspace_id);
  };
  const shareUser = (id) => {
    try {
      const nameAccess = allAccessWorkspace.filter(
        (adj) => adj.workspace_id === id
      );
      const result = nameAccess?.email ? nameAccess?.email : "";
      return result.slice(0, 2);
    } catch (error) {
      return 0;
    }
  };

  const handleDelete = async (w_id) => {
    swal({
      title: "Are you sure",
      text: "you want to delete this Workspace ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, archive it!",
      cancelButtonText: "No, cancel please!",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async (result) => {
      if (result === true) {
        const res = await deleteWorkspace(w_id);
        if (res.status === 200) {
          allWorkSpace();
          setAnchorE2(false);
        }
      }
    });
  };

  const checkingPermission = async (w_id) => {
    const workspace_id = w_id;
    checkDeleteAccess(workspace_id)
      .then(response => {
        if (response.data.missingCompanies.length === 0) {
          handleOpenApprovalModal();
          setWID(w_id);
        } else if (response.data.missingCompanies.length === response.data.approvedCompanies.length) {
          handleOpenApprovalModal();
          setWID(w_id);
        } else {
          swal("Success", "You Don't have full access to delete Workspace", "success");
          handleOpenRequestModal();
          setWID(w_id);
          setCompanyIds(response.data.missingCompanies);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  //search bar//
  const handleChange = (event) => {
    const searchData = event.target.value.toLowerCase();
    setSearch(searchData);
    if (searchData === '') {
      allWorkSpace();
    } else {
      const filerData = allWorkspace.filter(workspace => workspace?.workspace_name?.toLowerCase().includes(searchData));
      setWorkspace(filerData)
    }
  };

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`${commoncss.pageContent}`} >
          <div className={commoncss.w100} >

            <div className={commoncss.dFlexJustifysb} style={{
              position: "sticky",
              top: "0",
              zIndex: "10",
              padding: "12px 15px"
            }}>
              <motion.span initial={{ x: 1000, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }} className={commoncss.heading2}>My Workspace</motion.span>
              <motion.span
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
              >
                <span>
                  <span style={{ "vertical-align": "text-bottom" }}>
                    <SearchIcon className="mr-3" />
                    <MinimizeIcon className={`mr-3 ${commoncss.clickable}`} onClick={() => history.goBack()} />
                  </span>
                  {permissions?.companyData[0]?.components[0]?.permission?.create === true || permissions === null ? (
                    <Button
                      icon={<PlusIcon />}
                      btnColor={buttoncss.primary}
                      label={"Create new workspace"}
                      onClick={nextStep}
                    />
                  ) : (
                    <Button
                      icon={<PlusIcon />}
                      isEnabled={false}
                      btnColor={buttoncss.primary}
                      label={"Create new Workspace"}
                      onClick={''}
                    />
                  )
                  }
                </span>
              </motion.span>

            </div>
            <div className={workspacecss.workspaceContainer}>
              <div className={workspacecss.workSpaceCard}>
                {loader ? (
                  <div className={commoncss.fsTableLoaderDiv} >
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" style={{ margin: "1rem" }} />
                    <Spinner animation="grow" size="sm" />
                  </div>
                ) : (
                  <>
                    {
                      allWorkspace.length > 0 && allWorkspace.map((det, index) => {
                        const colIndex = index % 5; // 0-based column index in 5-column layout

                        // Define variation sets
                        const leftToRightVariants = [
                          { x: -120, y: -10, duration: 0.4 },
                          { x: -100, y: 5, duration: 0.6 },
                          { x: -150, y: 15, duration: 0.5 }
                        ];

                        const rightToLeftVariants = [
                          { x: 120, y: -10, duration: 0.4 },
                          { x: 100, y: 10, duration: 0.6 },
                          { x: 140, y: 20, duration: 0.5 }
                        ];

                        const middleColumnVariants = [
                          { x: -80, y: 0, duration: 0.5 },
                          { x: 80, y: 0, duration: 0.5 },
                          { x: 0, y: -100, duration: 0.6 },
                          { x: 0, y: 100, duration: 0.4 },
                          { x: -100, y: -100, duration: 0.7 }
                        ];

                        // Pick variant based on column
                        let variant;
                        if (colIndex <= 1) {
                          variant = leftToRightVariants[index % leftToRightVariants.length];
                        } else if (colIndex >= 3) {
                          variant = rightToLeftVariants[index % rightToLeftVariants.length];
                        } else {
                          variant = middleColumnVariants[index % middleColumnVariants.length];
                        }

                        return (
                          <>
                            <motion.div
                              key={det._id}
                              initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                              animate={{ x: 0, y: 0, opacity: 1 }}
                              transition={{ duration: variant.duration, ease: "easeOut" }}
                              className={`${cardcss.wsCardAll} ${commoncss.clickable}`}
                              onClick={() => handleClickData(det._id)}
                            >
                              <div className={`${cardcss.wsHeading} ${commoncss.dFlexJustifysb} ${cardcss.wsCardSelModules}`}>

                                {det.workspace_name ? det.workspace_name?.length > 30 ? (
                                  <div class="rtooltip" style={{ fontSize: "21px" }}>{det.workspace_name.substring(0, 28).concat('...')}
                                    <span class="rtooltiptext" >{det.workspace_name}</span>
                                  </div>
                                ) : (
                                  <>
                                    <span style={{ fontSize: "21px" }}>{det.workspace_name}</span>

                                    {/* {det.access_status === "view" ? (
                                                          <VisibilityIcon />
                                                        ) : (
                                                          // <VisibilityOffIcon/>
                                                          ""
                                                        )} */}

                                  </>
                                ) : <>
                                  {workspace(det.workspace_id, "id")}
                                </>}

                                <span className={cardcss.editDiv} onClick={(e) => { e.stopPropagation() }}

                                >
                                  {/* {det.access ? det.access === "Edit" ?
                                  <span className="font-inter rename-icons">
                                    <RenameSVGComponent height={14} width={14} color={'#32a899'} style={{ marginBottom: "2px", marginRight: "2px" }} />
                                    CAN EDIT
                                  </span> :
                                  <span className="font-inter view-icons">
                                    <VisibilityIcon style={{ fontSize: "14", color: "#5d615f", marginBottom: "1px", marginRight: "2px" }} />VIEW ONLY</span>
                                  : ""} */}
                                  <EditIcon width={20}
                                    onClick={(e) => { e.stopPropagation(); handleClickWsp(e, det._id, det) }}
                                    style={{ cursor: "pointer" }}
                                  />

                                  <Popover
                                    style={{ left: "-103px" }}
                                    id={idTab}
                                    open={openTab}
                                    anchorEl={anchorE2}
                                    onClose={handleCloseTab}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                  >
                                    <Typography className={`${cardcss.editWsDiv} mt-2`} sx={{}}>
                                      {/* <span
                                                              style={{
                                                                cursor: "pointer",
                                                                fontSize: "12px",
                                                              }}
                                                              onClick={() =>
                                                                handleViewOnly(WsPid, "off")
                                                              }
                                                            >
                            
                                                              <div className="viewIcon">
                                                                <VisibilityIcon className="mt-1 ml-3" style={{ width: "18px", height: "18px", color: "black" }} />
                                                                <span className="mt-1 ml-1 font-sans">View Only</span>
                                                              </div>
                                                            </span> */}
                                      <br />
                                      {workspaceDelete.access_status === "view" ? (
                                        <span
                                          className="font-sans "
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "grey",
                                          }}
                                        >
                                          {"Add Team Member"}
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          onClick={(e) => { e.stopPropagation(); handleAddTeam(WsPid) }}
                                        >
                                          <div className="view-options">
                                            <img
                                              className="icon-img ml-3"
                                              src={addTeamMemberIcon}
                                              alt="Add Team Member Icon"
                                              style={{
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                            <span className="mt-1 ml-1 font-sans ">Add Team Member</span>
                                          </div>
                                        </span>
                                      )}
                                      <br />
                                      {workspaceDelete.access_status === "view" ? (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "grey",
                                          }}
                                        >
                                          {"Duplicate"}
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          onClick={(e) => { e.stopPropagation(); handleDuplicate(WsPid) }}
                                        >
                                          <div className="view-options">
                                            <img className="icon-img ml-3"
                                              src={duplicateIcon}
                                              alt="Duplicate icon"
                                            />
                                            <span className="mt-1 ml-1 font-sans ">Duplicate</span>
                                          </div>
                                        </span>
                                      )}
                                      <br />
                                      {workspaceDelete.access_status === "view" ? (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "grey",
                                          }}
                                        >
                                          {"Rename"}
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          onClick={(e) => { e.stopPropagation(); handleRename(WsPid) }}
                                        >
                                          <div className="view-options">
                                            <img className="icon-img ml-3"
                                              src={renameIcon}
                                              alt="rename icon"
                                            />
                                            <span className="mt-1 ml-1 font-sans ">Rename</span>
                                          </div>
                                        </span>
                                      )}
                                      <br />
                                      {workspaceDelete.access_status === "view" ? (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "grey",
                                          }}
                                        >
                                          {"Delete"}
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          // disabled={users.responsibilities==="approver"}
                                          onClick={(e) => {
                                            if (users.responsibilities === "preparer") {
                                              e.stopPropagation();
                                              checkingPermission(WsPid)
                                            } else if (users.responsibilities === "approver" || users.responsibilities === "view") {
                                              e.stopPropagation();
                                            } else {
                                              e.stopPropagation();
                                              handleDelete(WsPid);
                                            }
                                          }}
                                        >
                                          <div className="view-options"
                                          >
                                            <img className="icon-img ml-3"
                                              src={deleteIcon}
                                              alt="rename icon"
                                            />
                                            <span className="mt-1 ml-1 font-sans">Delete</span>
                                          </div>
                                        </span>
                                      )}
                                    </Typography>
                                  </Popover>
                                </span>

                                <div className={commoncss.dFlexWrap}>
                                  {det.selectedModules && det.selectedModules.map((selModule) => {
                                    return (
                                      <StatusIndicator
                                        status="red"
                                        label={selModule}
                                      />
                                    )
                                  })}
                                </div>
                              </div>
                              <div>
                                {(det.standalone_cy || det.standalone_py) ? (
                                  <>
                                    <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>Current Year</span>
                                      {det.standalone_cy && moment(det.standalone_cy).isValid() ? (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                          {moment(det.standalone_cy).format("MMM DD, YYYY")}
                                        </span>
                                      ) : (() => {
                                        const wsDate = workspaceCy(det.workspace_id, "id");
                                        return moment(wsDate).isValid() ? (
                                          <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                            {moment(wsDate).format("MMM DD, YYYY")}
                                          </span>
                                        ) : (
                                          <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                        );
                                      })()}
                                    </div>

                                    <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>Previous Year</span>
                                      {det.standalone_py && moment(det.standalone_py).isValid() ? (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                          {moment(det.standalone_py).format("MMM DD, YYYY")}
                                        </span>
                                      ) : (() => {
                                        const wsPrevDate = workspacePy(det.workspace_id, "id");
                                        return moment(wsPrevDate).isValid() ? (
                                          <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                            {moment(wsPrevDate).format("MMM DD, YYYY")}
                                          </span>
                                        ) : (
                                          <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                        );
                                      })()}
                                    </div>
                                  </>
                                ) : (det.book_closure_as_on_date || det.createdAt) ? (
                                  <>
                                    <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>As on Date</span>
                                      {det.book_closure_as_on_date && moment(det.book_closure_as_on_date).isValid() ? (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                          {moment(det.book_closure_as_on_date).format("MMM DD, YYYY")}
                                        </span>
                                      ) : (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                      )}
                                    </div>
                                    <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>Created At</span>
                                      {det.createdAt && moment(det.createdAt).isValid() ? (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                          {moment(det.createdAt).format("MMM DD, YYYY")}
                                        </span>
                                      ) : (
                                        <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>Current Year</span>
                                      <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                    </div>

                                    <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                                      <span className={cardcss.wsLabelSm1}>Previous Year</span>
                                      <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                    </div>
                                  </>
                                )}
                                {/* <div className={`${cardcss.wsPeriod} w-100`}>
                            <span className={cardcss.wsLabel1}>Current Year</span>
                            {det.standalone_cy && moment(det.standalone_cy).isValid() ? (
                              <span className={cardcss.wsLabel1} style={{ color: "black" }}>
                                {moment(det.standalone_cy).format("MMM DD, YYYY")}
                              </span>
                            ) : (() => {
                              const wsDate = workspaceCy(det.workspace_id, "id");
                              return moment(wsDate).isValid() ? (
                                <span className={cardcss.wsLabel1} style={{ color: "black" }}>
                                  {moment(wsDate).format("MMM DD, YYYY")}
                                </span>
                              ) : (
                                <span className={cardcss.wsLabel1} style={{ color: "black" }}>—</span>
                              );
                            })()
                            }
                          </div>
                          <div className={`${cardcss.wsPeriod} w-100 mt-2`}>
                            <span className={cardcss.wsLabel1}>Previous Year</span>
                            {det.standalone_py && moment(det.standalone_py).isValid() ? (
                              <span className={cardcss.wsLabel1} style={{ color: "black" }}>
                                {moment(det.standalone_py).format("MMM DD, YYYY")}
                              </span>
                            ) : (() => {
                              const wsPrevDate = workspacePy(det.workspace_id, "id");
                              return moment(wsPrevDate).isValid() ? (
                                <span className={cardcss.wsLabel1} style={{ color: "black" }}>
                                  {moment(wsPrevDate).format("MMM DD, YYYY")}
                                </span>
                              ) : (
                                <span className={cardcss.wsLabel1} style={{ color: "black" }}>—</span>
                              );
                            })()
                            }
                          </div> */}
                                <div className="mt-2">
                                  {det?.workspace_name ?
                                    <span className={cardcss.wsLabel2} >{moment(det.createdAt).fromNow()}</span> :
                                    <div className={cardcss.wsLabel2}  >
                                      Shared by{" "}
                                      {UserName(det?.user_id).substring(
                                        0,
                                        UserName(det?.user_id).lastIndexOf("@")
                                      )}
                                    </div>}
                                </div>
                              </div>


                            </motion.div >
                          </>
                        )
                      })
                    }
                  </>
                )
                }
              </div>
            </div>

          </div>
        </div>
      </div >
      <SendRequest
        openRequestModal={openRequestModal}
        handleCloseRequestModal={handleCloseRequestModal}
        companyId={companyId}
        WID={WID}
        WSPDATA={workspaceDelete}
      />
      <SendApproval
        user={users}
        approverId={approverId}
        openApproveModal={openApproveModal}
        handleCloseApprovalModal={handleCloseApprovalModal}
        handleApproverChange={handleApproverChange}
        WID={WID}
        WSPDATA={workspaceDelete}
      />

      <Modal
        open={openRenameModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="col-12">
            <h5>Rename Workspace</h5>
            <form>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  defaultValue={workspace(renameId, "id")}
                  onChange={(e) => handleChangeData(e)}
                />
              </div>
              <input
                type="button"
                className="btn btn-primary1"
                value="Submit"
                onClick={submitCompany}
              />
              <input
                type="button"
                className="btn btn-defult"
                value="Close"
                onClick={handleClose}
              />
            </form>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default AllWorkspaceData;
